import { FC } from 'react'
import clsx from 'clsx'

interface IInitialsAvatar {
  src?: string | null
  name?: string | null
  className?: string
}

// deep enough for white initials at 4.5:1 and more (the 500 shades read at
// 2.1-4.2:1); the testimonials use them too
export const AVATAR_COLORS = [
  'bg-brand-strong',
  'bg-avatar-green',
  'bg-avatar-amber',
  'bg-avatar-rose',
  'bg-avatar-sky',
  'bg-avatar-violet',
]

// Standard avatar fallback: first letters of the name on a deterministic
// color instead of the shared stock photo (client request, roadmap 16.4).
// Meant to be rendered inside an existing rounded/overflow-hidden wrapper.
const InitialsAvatar: FC<IInitialsAvatar> = ({ src, name, className }) => {
  if (src) {
    return (
      <img loading="lazy" src={src} alt="" className={clsx('object-cover size-full', className)} />
    )
  }

  const cleanName = (name || '').trim()
  const initials =
    cleanName
      .split(/\s+/)
      .slice(0, 2)
      .map((word) => word.charAt(0).toUpperCase())
      .join('') || '?'
  const colorIndex = cleanName
    ? Array.from(cleanName).reduce((acc, char) => acc + char.charCodeAt(0), 0) %
      AVATAR_COLORS.length
    : 0

  return (
    <div
      className={clsx(
        'size-full flex items-center justify-center text-white text-sm font-semibold select-none',
        AVATAR_COLORS[colorIndex],
        className,
      )}
    >
      {initials}
    </div>
  )
}

export default InitialsAvatar
